import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function GlobalNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Left - Brand Name */}
          <Link 
            to="/" 
            className={`text-xl font-bold transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
          >
            TREX RE LLC
          </Link>

          {/* Right - Navigation Links */}
          <div className="hidden lg:flex items-center space-x-6">
            <a 
              href="https://trexrealestate.com/sell-apartments" 
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              We buy Apartments
            </a>
            <a 
              href="https://trexrealestate.com" 
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              We buy Houses
            </a>
            <a 
              href="https://trexrealestate.com/land-buyers" 
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              We buy Land
            </a>
            <a 
              href="https://trexrealestate.com/rental-property/rent-houses-apartments" 
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              We Rent Real Estate
            </a>
            <Link 
              to="/about" 
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              About
            </Link>
            <Link 
              to="/get-cash-offer-for-my-property" 
              className="px-6 py-2.5 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Cash Offer
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <Link 
              to="/get-cash-offer-for-my-property" 
              className="px-4 py-2 bg-teal-600 text-white rounded-lg font-semibold text-sm hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Offer
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
